const enum ThemeEnum {
  Light = 'light',
  Dark = 'dark',
}

export default ThemeEnum;
